import React, { useEffect, useState } from "react";
import { Flex, Dropdown, Text } from "@fluentui/react-northstar";
import PropTypes from "prop-types";
import { observer } from "mobx-react-lite";
import Constants from "../../../constants/text-constants";

const StatusDropDown = observer((props) => {
  const { items, currentStatusCode, currentReasonCode, onChange } = props;
  const [allItems, setAllItems] = useState([]);
  const [renderedItems, setRenderedItems] = useState([]);
  const [selectedStatusItem, setSelectedStatusItem] = useState({
    header: "",
    image: null,
  });

  useEffect(() => {
    const allDropdownItems = items.map((item) => {
      return {
        header: item.text,
        image: {
          as: item.icon,
        },
        statuscode: item.statusCode,
        reasoncode: item.reasonCode,
        selectable: item.selectable ? "true" : "false",
      };
    });
    setAllItems(allDropdownItems);

    const renderedItms = allDropdownItems.filter(
      (item) => item.selectable === "true"
    );
    setRenderedItems(renderedItms);
  }, [items]);

  useEffect(() => {
    const currentStatusItem = allItems.find((item) => {
      let selectedItem = null;

      if (item.statuscode === currentStatusCode.code) {
        if (currentReasonCode !== null) {
          if (item.reasoncode === currentReasonCode.code) {
            selectedItem = item;
          }
        } else {
          selectedItem = item;
        }
      }
      return selectedItem;
    });

    if (currentStatusItem) {
      setSelectedStatusItem(currentStatusItem);
    }
  }, [allItems, currentStatusCode, currentReasonCode]);

  return (
    <Flex column>
      <Text
        className="body-text"
        data-testid="myStatusDropdownTitle"
        content={Constants.STATUS_TITLE}
      />
      <Dropdown
        data-testid="myStatusDropdown"
        className="my-status-dropdown"
        triggerButton={{
          content: (
            <Text data-testid="selectedItemText" weight="semibold">
              {selectedStatusItem.header}
            </Text>
          ),
          icon: selectedStatusItem.image,
        }}
        items={renderedItems}
        onChange={(e, item) =>
          onChange(item.value.statuscode, item.value.reasoncode)
        }
      />
    </Flex>
  );
});

StatusDropDown.propTypes = {
  items: PropTypes.array,
  currentReasonCode: PropTypes.object,
  currentStatusCode: PropTypes.object,
  onChange: PropTypes.func,
};

StatusDropDown.defaultProps = {
  items: [],
  currentReasonCode: {},
  currentStatusCode: {},
};

export default StatusDropDown;
